export const OUTLET_THEMES = {
  mint: 'mint',
  warm: 'warm',
}

export const OUTLET_THEME_DESCRIPTIONS = {
  [OUTLET_THEMES.mint]: 'Товар із коротшим залишковим терміном придатності.',
  [OUTLET_THEMES.warm]: 'Спеціальна outlet-пропозиція в обмеженій кількості.',
}

const MINT_OUTLET_REASONS = new Set(['productExpiration'])

export const getOutletTheme = (outletReason) =>
  MINT_OUTLET_REASONS.has(outletReason) ? OUTLET_THEMES.mint : OUTLET_THEMES.warm

/** Gifts are add-ons — catalog mix/theme comes from paid lines only. */
const getPaidProducts = (products) =>
  (Array.isArray(products) ? products : []).filter((product) => !product?.isGift)

export const getOrderOutletReason = (products) => {
  const list = getPaidProducts(products)
  const outletProduct = list.find((product) => product.isOutlet === true)

  if (!outletProduct) {
    return null
  }

  return outletProduct.outletReasonType || outletProduct.outletReason || null
}

export const getOrderOutletTheme = (products) => {
  const list = getPaidProducts(products)
  const outletProducts = list.filter((product) => product.isOutlet === true)

  if (!outletProducts.length) {
    return null
  }

  const themes = outletProducts.map((product) =>
    getOutletTheme(product.outletReasonType || product.outletReason)
  )
  const hasMint = themes.includes(OUTLET_THEMES.mint)
  const hasWarm = themes.includes(OUTLET_THEMES.warm)

  if (hasMint && hasWarm) {
    return null
  }

  return hasMint ? OUTLET_THEMES.mint : OUTLET_THEMES.warm
}
